import React from 'react';
import type { DefaultAutomationTemplateMetadata } from '@reach/shared-types/automation-template';
import { Button } from '../../../components/ui/button';
import { useCreatePartnerCopyOfDefaultAutomation } from '../useAutomationTemplates';
import styles from './EngageAutomationsTab.module.css';

interface DefaultTemplateButtonsProps {
  metadata: DefaultAutomationTemplateMetadata[];
}

export const DefaultTemplateButtons: React.FC<DefaultTemplateButtonsProps> = ({
  metadata,
}) => {
  const copyMutation = useCreatePartnerCopyOfDefaultAutomation();

  if (!metadata || metadata.length === 0) {
    return null;
  }

  const handleButtonClick = (templateName: string) => {
    copyMutation.mutate(templateName);
  };

  return (
    <div className={styles.buttonsContainer}>
      Start from a template:
      <div className={styles.buttonsWrapper}>
        {metadata.map(template => (
          <Button
            key={template.name}
            variant="outline"
            size="sm"
            title={template.description}
            className="text-sm"
            onClick={() => handleButtonClick(template.name)}
            disabled={copyMutation.isPending}>
            {template.displayName}
          </Button>
        ))}
      </div>
    </div>
  );
};
